/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCustomGroup {
    getFixupPrototypeFunction() { return BillingCustomGroup.fixupPrototype; }

    static newInstance(model: Partial<BillingCustomGroup>): BillingCustomGroup {
        let obj = Object.assign(new BillingCustomGroup(), model);
        BillingCustomGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCustomGroup>): BillingCustomGroup {
        if (!model) return null;
        return BillingCustomGroup.newInstance(<BillingCustomGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCustomGroup) {
        if (!obj) return;

        models.BillingCustomGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCustomGroup): boolean {
        Object.setPrototypeOf(obj, BillingCustomGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.QueryOperator.fixupPrototype(this.filter);
        }
    }

    /**
     * Value for the group
     */
    attribute_value: string;

    /**
     * Key for the group
     */
    attribute_key: string;

    /**
     * Filter for the custom group
     */
    filter: models.QueryOperator;

    /**
     * Grouping Rule ID
     */
    grouping_rule_id: string;

    /**
     * Dimension ID
     */
    dimension_id: string;

}
